import { AccessHistoryApi } from '@api';
import { accessHistoryTypes as actionTypes } from './types';

export const fetchAccessHistories = (params) => (dispatch) => {
  dispatch({
    type: actionTypes.LIST.LOADING,
  });

  AccessHistoryApi.getList(params)
    .then((response) => {
      dispatch({
        type: actionTypes.LIST.SUCCESS,
        payload: response,
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.LIST.FAILURE,
        message: `notify:general.errors.${error.status}`,
      });
    });
};

export const distrustAccessHistory = (id) => (dispatch) => {
  dispatch({
    type: actionTypes.DISTRUST.LOADING,
  });

  AccessHistoryApi.distrust(id)
    .then((response) => {
      dispatch({
        type: actionTypes.LIST.HYDRATE,
        payload: response,
        method: 'add',
      });

      dispatch({
        type: actionTypes.DISTRUST.SUCCESS,
        payload: response,
        message: 'notify:general.save.success',
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.DISTRUST.FAILURE,
        message: `notify:general.save.error.${error.status}`,
      });
    });
};
